import { NID_CHECK_MARITAL } from "redux/actions/actiontype";

const initialState = {
  loading: false,
  data: null, // Use null instead of an empty object for clarity
  error: '',
};

const maritalStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${NID_CHECK_MARITAL}_PENDING`:
      return {
        ...state,
        loading: true,
        error: '',
        data: null,
      };
    case `${NID_CHECK_MARITAL}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload, // The payload is the marital status string
        error: '',
      };
    case `${NID_CHECK_MARITAL}_REJECTED`:
      return {
        ...state,
        loading: false,
        error: action.payload?.message || 'Failed to fetch marital status',
      };
    default:
      return state;
  }
};

export default maritalStatusReducer;